import { useRuntimeConfig } from '#app';
import appConfig from '~/env.config.json';
import type { RecipeProps } from '~/types/crafting';

const nonActiveRecipeIds: Record<string, number[]> = {
  test: [
    97, 98, 20, 21, 68, 22, 100, 24, 25, 42, 99, 49, 51, 53, 55, 58, 69, 70, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88,
    89, 90, 96, 122, 124, 126, 128, 130, 127, 125, 4, 7, 9, 26, 27, 28, 43, 44, 45, 46, 47
  ],
  prod: [
    79, 80, 11, 32, 52, 12, 82, 14, 15, 33, 81, 40, 42, 44, 46, 49, 53, 54, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70,
    71, 72, 78, 103, 105, 107, 109, 111, 108, 106, 1, 2, 7, 3, 4, 8, 5, 6, 9, 16, 17, 18, 34, 35, 36, 37, 38
  ],
  demo: [],
  local: []
};

nonActiveRecipeIds.local = nonActiveRecipeIds.test;

export default () => {
  const config = useRuntimeConfig();
  const env = config.public.env as keyof typeof appConfig;

  return {
    reformatRecipesResponse: (recipes: RecipeProps[]) => {
      const nonActiveIds = nonActiveRecipeIds[env] ?? [];

      return recipes.map((recipe) => {
        if (nonActiveIds.includes(parseInt(recipe.recipeId))) {
          recipe.isActive = false;
        }
        return recipe;
      });
    }
  };
};
